module.exports = __webpack_public_path__ + "static/media/master-card-light.8a6fb5c0.svg";